module.exports = __webpack_public_path__ + "img/11069856_L.37cba5d4.png";